import { handleGAEvent } from "../helpers/googleAnalytics";

const CtaBanner = () => {
  return (
    <div className="cta-banner-wrapper">
      <div className="cta-banner-container container">
        <div className="text-side">
            <div className="label">Available</div>
            <div className="description">
                Want to work together?
            </div>
        </div>
        <div className="cta">
          <a href="https://calendar.app.google/Nt4BTmPCNJvfy2Hw8" target="_blank" onClick={() => handleGAEvent('book_a_call')}>
            book a call
          </a>
        </div>
      </div>
    </div>
  );
};

export default CtaBanner;